import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../pages/Home'
import ShareLink from '../pages/ShareLink'
import SocialRedirect from '../pages/SocialRedirect'
import ShareContent from '../pages/ShareContent'
import ShareStatus from '../pages/ShareStatus'
import Tip from '../pages/Tip'
import NotFound from '../pages/NotFound'

const routes = [
  {
    path: '/',
    component: Home,
    meta: {
      title: 'meta.title.home'
    }
  },
  {
    path: '/s/:key',
    component: ShareLink,
    meta: {
      title: 'share.link.title'
    }
  },
  {
    path: '/social/login/callback/:socialType',
    component: SocialRedirect,
    meta: {
      title: 'meta.title.socialRedirect'
    }
  },
  {
    path: '/share/:socialType/:fileType',
    component: ShareContent,
    meta: {
      title: 'meta.title.shareContent'
    }
  },
  {
    path: '/status',
    component: ShareStatus,
    meta: {
      title: 'meta.title.shareStatus'
    }
  },
  {
    path: '/tip',
    component: Tip,
    meta: {
      title: 'meta.title.tip'
    }
  },
  {
    path: '/404',
    component: NotFound,
    meta: {
      title: '404 Not Found!'
    }
  },
  {
    path: '*',
    redirect: '/404'
  }
]

Vue.use(VueRouter)

const router = new VueRouter({
  routes
})
router.beforeEach((to, from, next) => {
  let local = to.query.lang
  if(local) {
    router.app.$i18n.locale = local
  }
  next()
})

export default router